<script setup>
defineProps({
	word: {
		type: String,
		default: "",
	},
});
</script>
<template>
	<div class="current-word" :class="{ active: word.length > 0 }">
		<span v-if="word" class="word-text">{{ word }}</span>
		<span v-else class="placeholder">Проведи по буквам</span>
	</div>
</template>


<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.current-word {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1.6rem;
	transition: all 0.2s ease;
	@media (max-width: vars.$x480) {
		margin-bottom: 1rem;
	}
}

.word-text {
	font-family: var(--second-family);
	font-weight: 700;
	font-size: 2.8rem;
	line-height: 110%;
	text-transform: uppercase;
	text-align: center;
	color: var(--text-accent-2-100);
	@media (max-width: vars.$x480) {
		font-size: 1.4rem;
	}
}

.placeholder {
	font-size: 16px;
	color: rgba(255, 255, 255, 0.4);
}

.current-word.active {
	transform: scale(1.05);
}
</style>
